import filterLinebreaksBr from 'common/filters/filterLinebreaksBr'
import filterRemoveEmailSitePhone from 'common/filters/filterRemoveEmailSitePhone'
import type { CommonContextStore } from 'src/types/context'
import tDynamic from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/tDynamic'
import type { Rate } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuReviews/types'

const REPLY_TRUNCATE_LENGTH = 1000

/**
 * HTML ответа клиники или модератора.
 *
 * При `shouldStripContacts` из текста вырезаются телефон, email и сайт:
 * иначе они остаются в публичной карточке.
 * Хосты из `ALLOWED_HOSTS` фильтр не трогает.
 */
export function getReplyHtml(
  rate: Rate,
  field: 'lpu_reply' | 'moderator',
  shouldStripContacts: boolean,
  context: CommonContextStore['context'],
): string {
  const text = tDynamic(rate, field)

  if (!text) {
    return ''
  }

  const prepared = shouldStripContacts
    ? filterRemoveEmailSitePhone(text, 'hard', context.ALLOWED_HOSTS ?? [])
    : text

  return filterLinebreaksBr(prepared)
}

/**
 * Нужно ли сворачивать ответ.
 *
 * Сравнивается длина HTML, а не видимого текста:
 * разметка переносов тоже входит в лимит 1000.
 */
export function isReplyTruncated(html: string): boolean {
  return html.length > REPLY_TRUNCATE_LENGTH
}
